// TODO: Make this service usable.
// We put so much noisy junk into Airbrake
// that we are not able to get any value out of it.
// We will incrementally start pushing logs to Airbrake again
// being sure that we are adding value, not noise.

export default {
  client: { addFilter: () => {} },
  notify(err) {
    /* eslint-disable */
    console.error(err);
    /* eslint-enable */
    return Promise.resolve('[logged to console]');
  }
};
